// Shared async loader for recommendation rails ("You might also like").
//
// Used by both sections/product-recommendations.liquid (PDP) and
// sections/cart-recommendations.liquid (cart). Each rail first renders a
// skeleton plus a [data-fetch-url] pointing at Shopify's recommendations
// endpoint (Section Rendering API). This script fetches that URL and swaps
// the skeleton for the real product grid, so the recommendations query never
// blocks first paint.
//
// Idempotent: guards on data-loaded, so it's safe to include from more than
// one section and to run more than once.

(function () {
  async function loadRail(container) {
    if (container.dataset.loaded === 'true') return;
    container.dataset.loaded = 'true'; // guard against a double fetch

    const url = container.dataset.fetchUrl;
    if (!url) return;

    try {
      const res = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!res.ok) {
        container.remove();
        return;
      }
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-product-recommendations]');
      if (!fresh) {
        // No recommendations available — drop the skeleton silently.
        container.remove();
        return;
      }
      fresh.dataset.loaded = 'true';
      container.replaceWith(fresh);
    } catch (error) {
      console.warn('[recommendations] fetch failed:', error);
      container.remove();
    }
  }

  function initRecommendations() {
    document
      .querySelectorAll('[data-product-recommendations]:not([data-loaded])')
      .forEach(loadRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendations);
  } else {
    initRecommendations();
  }
})();
